module.exports = __webpack_public_path__ + "img/21_10.a0588e36.png";